import { Action, CustomTagType, DockType, ErrorCodes, OperationType, Position, WindowType } from "puzzle";
import RateDetails from "../components/Drawer/Tabs/QuotesReview/RateDetails/RateDetails";
import ApproveQuotes from "../components/Drawer/Tabs/QuotesReview/ApproveQuotes/ApproveQuotes";
import RequestQuoteUpdate from "../components/Drawer/Tabs/QuotesReview/RequestQuoteUpdate/RequestQuoteUpdate"
import CommentsDialog from "../components/Drawer/Tabs/QuotesReview/CommentsDialog/CommentsDialog"
import DownloadQuote from "../components/SubmissionsList/ActionToolbar/DownloadQuote/DownloadQuote";
import AddEditPo from "../components/Drawer/Tabs/QuotesReview/AddEditPO/AddEditPO";

export const openQuoteRateDetails: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  data: {
    template: {
      asSubName: true,
      bind: {
        submissionName: '{selectedSubmissions[0].submissionName}',
        submissionId: '{selectedSubmissions[0].submissionId}'
      }
    }
  },
  type: OperationType.data
}, {
  title: 'rateDetails.title',
  children: [{
    render: RateDetails,
    propArgs: ['quotesData', 'vendorId', 'languageId']
  }],
  className: 'xl rate-details',
  items: [{
    operations: [],
    btnName: 'rateDetailsHeader',
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    }
  }, {
    btnName: 'rateDetails.close',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    },
    operations: []
  }],
  type: OperationType.dialog
}, {
  waitForModule: true,
  moduleName: 'RateDetails',
  name: 'loadData'
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const openRequestQuoteUpdateDialog: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule,

}, {
  data: {
    template: {
      bind: {
        vendorName: '{vendor.vendorName}',
      }
    }
  },
  type: OperationType.data,
}, {
  data: {
    template: {
      bind: {
        userName: `_.get({initializeUserData},"userProfile.userInfo.userName")`,
      }
    },
  },
  type: OperationType.data,
}, {
  title: 'requestQuoteUpdate.title',
  children: [{
    render: RequestQuoteUpdate,
    propArgs: ['quotesData', 'vendor', 'userName']
  }],
  className: 'lg with-custom-header quote-update',
  items: [
    {
      btnName: 'vendorName',
      btnConfig: {
        args: ['vendorName', '', 'vendorName'],
        customTagType: CustomTagType.label,
        dock: DockType.top,
        pos: Position.end
      }
    },
    {
      btnName: 'cancel',
      operations: [],
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      }
    }, {
      btnName: 'requestQuoteUpdate.submit_button',
      btnConfig: {
        themeColor: 'primary',
        disabled: true,
        pos: Position.end
      },
      close: false,
      operations: [{
        title: 'requestQuoteUpdate.title',
        text: 'requestQuoteUpdate.text',
        type: OperationType.warning,
        className: 'sm confirm-light',
        items: [{
          btnName: 'requestQuoteUpdate.back',
          operations: [{
            windowType: WindowType.warning,
            type: OperationType.closeWindow
          }],
          btnConfig: {
            fillMode: 'flat',
            pos: Position.end
          }
        }, {
          btnName: 'requestQuoteUpdate.requestConfirm',
          btnConfig: {
            themeColor: 'primary',
            pos: Position.end
          },
          operations: [
            {
              name: 'postRequestUpdate',
              type: OperationType.action
            }, {
              windowType: WindowType.warning,
              type: OperationType.closeWindow
            }, {
              windowType: WindowType.dialog,
              type: OperationType.closeWindow
            }],
        }]
      }]
    }],
  type: OperationType.dialog
}, {
  moduleName: 'RequestQuoteUpdate',
  name: 'getQueryParams',
  mappingName: 'queryString',
  type: OperationType.addOperationData
}, {
  data: {
    method: 'get',
    template: {
      bind: {
        url: '"/submissions/"+{selectedSubmissions[0].submissionId}+"/quote/comments/vendor/" + {vendor.vendorId}',
        params: '{queryString}',
      }
    }
  },
  mappingName: 'commentsData',
  type: OperationType.request
}, {
  moduleName: 'RequestQuoteUpdate',
  name: 'setCommentsData',
  args: ['commentsData']
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const quote_request: Action = [{
  persistent: ['submissionData'],
  type: OperationType.addPersistentData
}, {
  items: [{
    operations: [{
      persistent: ['submissionData'],
      type: OperationType.removePersistentData
    }, {
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }],
    btnName: 'requestQuote.cancel',
    close: false,
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  },
    {
      operations: [{
        moduleName: 'App',
        type: OperationType.maskModule
      }, {
        windowType: WindowType.warning,
        type: OperationType.closeWindow
      }, {
        data: {
          template: {
            bind: {
              url: '"/submissions/" + {submissionData.submissionId} + "/quote/request"',
            }
          }
        },
        type: OperationType.request
      }, {
        name: 'refreshMainGridOnCurrentPosition',
        type: OperationType.action
      }, {
        moduleName: 'App',
        type: OperationType.unmaskModule
      }, {
        persistent: ['submissionData'],
        type: OperationType.removePersistentData
      }],
      btnName: 'requestQuote.yes',
      close: false,
      btnConfig: {
        pos: Position.end,
        themeColor: 'primary',
      }
    }],
  className: 'sm confirm-light',
  text: 'requestQuote.text',
  title: 'requestQuote.title',
  type: OperationType.warning
}];

export const quote_withdraw: Action = [{
  persistent: ['submissionData'],
  type: OperationType.addPersistentData
}, {
  items: [{
    operations: [{
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }, {
      persistent: ['submissionData'],
      type: OperationType.removePersistentData
    }],
    btnName: 'withdrawnQuote.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      moduleName: 'App',
      type: OperationType.maskModule
    }, {
      data: {
        template: {
          bind: {
            url: '"/submissions/" + {submissionData.submissionId} + "/quote/withdraw"',
          }
        }
      },
      mappingName: 'withdrawResponse',
      handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
      type: OperationType.request
    }, {
      data: {
        template: {
          bind: {
            responseData: '{withdrawResponse}'
          }
        }
      },
      name: 'handleRequestException',
      type: OperationType.action
    }, {
      name: 'refreshMainGridOnCurrentPosition',
      type: OperationType.action
    }, {
      moduleName: 'App',
      type: OperationType.unmaskModule
    }, {
      persistent: ['submissionData'],
      type: OperationType.removePersistentData
    }],
    btnName: 'withdrawnQuote.yes',
    btnConfig: {
      pos: Position.end,
      themeColor: 'error',
    }
  }],
  className: 'sm confirm-light',
  text: 'withdrawnQuote.text',
  title: 'withdrawnQuote.title',
  type: OperationType.warning
}];

export const approveQuote: Action = [{
  moduleName: 'ApproveQuotes',
  name: 'isApproveAllowed',
  type: OperationType.addOperationData
}, {
  condition: '{isApproveAllowed}',
  conditionOperations: [{
    moduleName: 'ApproveQuotes',
    name: 'getDataForPost',
    type: OperationType.addOperationData,
    mappingName: 'jsonData'
  }, {
    data: {
      template: {
        asSubName: true,
        bind: {
          submissionId: '{selectedSubmissions[0].submissionId}',
        }
      }
    },
    type: OperationType.data
  }, {
    handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
    data: {
      template: {
        bind: {
          url: '"/submissions/"+{submissionId}+"/quote/approve"',
          params: '{jsonData}'
        }
      }
    },
    mappingName: 'submissionApproveResponseData',
    type: OperationType.request
  }, {
    data: {
      template: {
        bind: {
          responseData: '{submissionApproveResponseData}'
        }
      }
    },
    name: 'handleRequestException',
    type: OperationType.action
  }, {
    name: 'approveSubmissionClose',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const openApproveQuotesDialog: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  data: {
    method: 'get',
    template: {
      bind: {
        url: '"/submissions/"+{selectedSubmissions[0].submissionId}+"/quotes/comments"'
      }
    }
  },
  mappingName: 'commentsData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        userName: `_.get({initializeUserData},"userProfile.userInfo.userName")`,
      }
    },
  },
  type: OperationType.data,
}, {
  data: {
    template: {
      asSubName: true,
      bind: {
        submissionId: '{selectedSubmissions[0].submissionId}',
        submissionName: '{selectedSubmissions[0].submissionName}'
      }
    }
  },
  type: OperationType.data
}, {
  children: [{
    render: ApproveQuotes,
    propArgs: ['data', 'commentsData', 'userName', 'submissionId', 'grandTotal', 'currency']
  }],
  className: 'xl with-custom-header approve-quote',
  items: [{
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    }
  }],
  title: 'approveQuotesDialog.title',
  type: OperationType.dialog
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const approveSubmissionClose: Action = [{
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  persistent: ['errorMessageText'],
  type: OperationType.removePersistentData
}, {
  windowType: WindowType.warning,
  type: OperationType.closeWindow
}, {
  name: 'refreshGridAfterQuoteAction',
  type: OperationType.action
}];

export const getQuotesReview: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  name: 'getProjectPolicies',
  type: OperationType.action
}, {
  handleError: true,
  data: {
    method: 'get',
    template: {
      bind: {
        url: '"/submissions/"+{submissionId}+"/quote/review"'
      }
    }
  },
  mappingName: 'quotesData',
  type: OperationType.request
}, {
  args: ['quotesData'],
  moduleName: 'QuotesReview',
  name: 'setData'
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const openCommentsDialog: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  data: {
    template: {
      asSubName: true,
      bind: {
        submissionName: '{selectedSubmissions[0].submissionName}',
        submissionId: '{selectedSubmissions[0].submissionId}'
      }
    }
  },
  type: OperationType.data
}, {
  data: {
    method: 'get',
    template: {
      bind: {
        url: '"/submissions/"+{submissionId}+"/quotes/comments"'
      }
    }
  },
  mappingName: 'commentsData',
  type: OperationType.request
},
  {
    title: 'commentsDialog.title',
    children: [{
      render: CommentsDialog,
      propArgs: ['commentsData', 'vendorId']
    }],
    className: 'xl with-custom-header comments',
    items: [
      {
        btnName: 'vendorName',
        btnConfig: {
          args: ['submissionId', 'submissionName', 'asSubName'],
          customTagType: CustomTagType.label,
          dock: DockType.top,
          pos: Position.end
        }
      },
      {
        btnName: 'commentsDialog.close',
        operations: [],
        btnConfig: {
          themeColor: 'primary',
          pos: Position.end
        }
      }],
    type: OperationType.dialog
  },
  {
    moduleName: 'App',
    type: OperationType.unmaskModule
  }];

export const postRequestUpdate: Action = [{
  moduleName: 'RequestQuoteUpdate',
  name: 'handleSubmitUpdateRequest',
  mappingName: 'jsonForPost',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      asSubName: true,
      bind: {
        submissionId: '{selectedSubmissions[0].submissionId}',
      }
    }
  },
  type: OperationType.data
}, {
  data: {
    method: 'post',
    template: {
      bind: {
        url: '"/submissions/"+{submissionId}+"/quote/request/update"',
        params: '{jsonForPost}'
      }
    }
  },
  mappingName: 'quotesUpdate',
  type: OperationType.request
}, {
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  name: 'refreshGridAfterQuoteAction',
  type: OperationType.action
}];

export const refreshGridAfterQuoteAction: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule,
}, {
  name: 'refreshMainGridToCurrentPositionWithoutMask',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        projectId: '{selectedSubmissions[0].projectId}',
        submissionId: '{selectedSubmissions[0].submissionId}',
      }
    }
  },
  type: OperationType.data
}, {
  name: 'getQuotesReview',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const downloadQuoteDialog: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    method: 'get',
    template: {
      bind: {
        url: '"/submissions/"+{submissionData.submissionId}+"/quote/report"'
      }
    }
  },
  mappingName: 'downloadQuoteData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        endpointPrefix: '{errorHandlerPrefix} || "QUOTE_DOWNLOAD_"',
        responseData: '{downloadQuoteData}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  title: 'downloadQuote.title',
  children: [{
    render: DownloadQuote,
    propArgs: ['fromAction']
  }],
  className: 'sm download-quote',
  items: [{
    btnName: 'downloadQuote.cancel',
    btnConfig: {
      pos: Position.end,
      hidden: true
    },
    operations: []
  }, {
    btnName: 'downloadQuote.backToQuote',
    btnConfig: {
      pos: Position.end,
      fillMode: 'flat',
      hidden: true
    },
    operations: []
  }, {
    btnName: 'downloadQuote.csv',
    btnConfig: {
      disabled: true,
      pos: Position.end,
      themeColor: 'primary'
    },
    operations: [{
      data: {
        template: {
          format: 'csv'
        },
      },
      type: OperationType.data
    }, {
      name: 'downloadQuoteReport',
      type: OperationType.action
    }],
  }, {
    operations: [{
      data: {
        template: {
          format: 'pdf'
        },
      },
      type: OperationType.data
    }, {
      name: 'downloadQuoteReport',
      type: OperationType.action
    }],
    btnName: 'downloadQuote.pdf',
    btnConfig: {
      disabled: true,
      pos: Position.end,
      themeColor: 'primary',
    }
  }],
  type: OperationType.dialog
}, {
  waitForModule: true,
  moduleName: 'DownloadQuote',
  args: ['downloadQuoteData'],
  name: 'setData'
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const quote_review_report: Action = [{
  data: {
    fromAction: true
  },
  type: OperationType.data
}, {
  name: 'downloadQuoteDialog',
  type: OperationType.action
}];

export const openDownloadQuote: Action = [{
  data: {
    fromAction: false
  },
  type: OperationType.data
}, {
  name: 'downloadQuoteDialog',
  type: OperationType.action
}];

export const updateDownloadQuoteFooter: Action = [{
  buttons: [{
    name: 'downloadQuote.cancel',
    hidden: '!{fromAction}'
  }, {
    name: 'downloadQuote.backToQuote',
    hidden: '{fromAction}'
  }, {
    name: 'downloadQuote.pdf',
    disabled: '{disableButtons}'
  }, {
    name: 'downloadQuote.csv',
    disabled: '{disableButtons}'
  }],
  type: OperationType.updateDialog
}];

export const downloadQuoteReport: Action = [{
  moduleName: 'DownloadQuote',
  name: 'getDownloadParams',
  args: ['format'],
  mappingName: 'params',
  type: OperationType.addOperationData
}, {
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  name: 'downloadToaster',
  type: OperationType.action
}, {
  name: 'pingForQuoteReport',
  type: OperationType.action
}];

export const pingForQuoteReport: Action = [{
  ping: {
    template: {
      method: 'post',
      bind: {
        url: '"/submissions/" + ({submissionId} ? {submissionId} : {selectedSubmissions[0].submissionId}) + "/quote/report"'
      }
    }
  },
  pingBreakCondition: ['errors'],
  pingCondition: 'processingFinished',
  delay: 1000,
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  pingErrorOperations: [{
    data: {
      template: {
        responseData: {
          response: {
            bind: {
              data: '{pingResponseDownloadData}',
              status: '{responseStatus}'
            }
          }
        }
      }
    },
    name: 'handleRequestException',
    type: OperationType.action
  }],
  mappingName: 'pingResponseDownloadData',
  download: {
    template: {
      method: 'get',
      bind: {
        url: "'/submissions/download/' + {pingResponseDownloadData.downloadId}",
      }
    }
  },
  withIndicator: false,
  pingOperations: [],
  type: OperationType.pingDownload
}];

export const openQuoteReviewTab: Action = [{
  moduleName: 'SubmissionsList',
  name: 'isDrawerOpen',
  type: OperationType.addOperationData
}, {
  condition: '{isDrawerOpen}',
  conditionOperations: [{
    data: {
      tabName: 'QUOTES'
    },
    args: ['tabName'],
    moduleName: 'SubmissionsList',
    name: 'getDrawerTabIndexByName',
    mappingName: 'tabIndex',
    type: OperationType.addOperationData
  }, {
    persistent: ['tabIndex'],
    type: OperationType.addPersistentData
  }, {
    name: 'changeDrawerTab',
    type: OperationType.action
  }],
  elseOperations: [{
    data: {
      filesInView: false,
      forceOpenDrawer: true,
      quotesInView: true,
      template: {
        bind: {
          selectedSubmissions: '[{submissionData}]'
        }
      }
    },
    executeType: 'visible',
    moduleName: 'SubmissionsList',
    name: 'gridOnSelectionChange',
    args: ['selectedSubmissions', 'forceOpenDrawer', 'quotesInView', 'filesInView']
  }],
  type: OperationType.conditional
}, {
  name: 'updateDrawerState',
  type: OperationType.action
}];

export const quote_review: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  condition: '{route() === "view/dashboard"}',
  conditionOperations: [{
    moduleName: 'Dashboard',
    name: 'prepareFilterData',
    args: ['submissionData'],
    type: OperationType.addOperationData
  }, {
    data: {
      template: {
        decodeFilter: true,
        path: '/view/submissionList',
        filter: {
          bind: {
            searchData: '{prepareFilterData}'
          }
        }
      }
    },
    type: OperationType.data
  }, {
    name: 'openPrefilteredSubmissionList',
    type: OperationType.action
  }, {
    moduleName: 'NavigationGrid',
    name: 'selectFirst'
  }],
  type: OperationType.conditional
}, {
  name: 'openQuoteReviewTab',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const updateRequestUpdateButton: Action = [{
  buttons: [{
    name: 'requestQuoteUpdate.submit_button',
    disabled: '!{buttonDisabled}'
  }],
  type: OperationType.updateDialog
}];

export const clearQuoteReviewConfirmation: Action = [{
  items: [{
    btnConfig: {
      dock: DockType.bottom,
      fillMode: 'flat',
      pos: Position.end
    },
    btnName: 'clearQuoteReview.no'
  }, {
    btnConfig: {
      dock: DockType.bottom,
      pos: Position.end,
      themeColor: 'error'
    },
    btnName: 'clearQuoteReview.yes',
    operations: [{
      moduleName: 'QuotesReview',
      name: 'clearAllChanges'
    }]
  }],
  text: 'clearQuoteReview.text',
  title: 'clearQuoteReview.title',
  className: 'sm confirm-light',
  type: OperationType.warning
}];

export const updateApproveQuoteGrandTotal: Action = [{
  data: {
    grandTotalText: 'approveQuotesDialog.grandTotalText',
  },
  buttons: [],
  customTags: [{
    name: 'approveQuotesDialog.grandTotal',
    args: ['grandTotalText', 'grandTotal'],
  }],
  type: OperationType.updateDialog,
}];

export const quote_add_edit_po: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  data: {
    template: {
      asSubName: true,
      grandTotalText: 'approveQuotesDialog.grandTotalText',
      bind: {
        grandTotal: '{grandTotal}',
        submissionName: '{selectedSubmissions[0].submissionName}',
        submissionId: '{selectedSubmissions[0].submissionId}'
      }
    }
  },
  type: OperationType.data
}, {
  data: {
    method: 'get',
    template: {
      bind: {
        url: '"/submissions/"+{selectedSubmissions[0].submissionId}+"/quotes/addEditPO"'
      }
    }
  },
  mappingName: 'data',
  type: OperationType.request
}, {
  children: [{
    render: AddEditPo,
    propArgs: ['data']
  }],
  className: 'xxl with-custom-header approve-quote add-edit-po',
  items: [{
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName', 'submissionId'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    },
    btnName: 'submissionName'
  }, {
    btnConfig: {
      dock: DockType.bottom,
      pos: Position.start,
      fillMode: 'flat'
    },
    btnName: 'approveQuotesDialog.cancel'
  }, {
    operations: [],
    btnName: 'approveQuotesDialog.grandTotal',
    btnConfig: {
      dock: DockType.bottom,
      pos: Position.end,
      customTagType: CustomTagType.counter,
      args: ['grandTotalText', 'grandTotal'],
    }
  }, {
    operations: [{
      moduleName: 'AddEditPO',
      name: 'isApproveAllowed',
      type: OperationType.addOperationData
    }, {
      condition: '{isApproveAllowed}',
      conditionOperations: [{
        moduleName: 'AddEditPO',
        name: 'getDataForPost',
        type: OperationType.addOperationData,
        mappingName: 'jsonForPost'
      }, {
        data: {
          method: 'post',
          template: {
            bind: {
              url: '"/submissions/"+{selectedSubmissions[0].submissionId}+"/quotes/addEditPO"',
              params: '{jsonForPost}'
            }
          }
        },
        mappingName: 'data',
        type: OperationType.request
      }, {
        windowType: WindowType.dialog,
        type: OperationType.closeWindow
      }],
      type: OperationType.conditional
    }],
    btnConfig: {
      themeColor: 'primary',
      dock: DockType.bottom,
      pos: Position.end
    },
    close: false,
    btnName: 'addEditPO.ok'
  }],
  title: 'addEditPO.title',
  type: OperationType.dialog
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];
